module.exports = __webpack_public_path__ + "static/media/resource_list.a9431eda.png";